<template>
  <div class="container">
    <p class="page-description">
      Entre no minhamola usando
    </p>
    <span v-if="isCORSError" class="error-cors-message"
      @click="reloadPage">
        Ocorreu um erro. Clique aqui para recarregar a página &#9932;</span>
    <div class="login-options">
      <span class="phone-number-login" :class="phoneIsActive"
        @click="changeLoginMethod" id="phone">Número de celular</span>
      <span class="email-login" :class="emailIsActive"
        @click="changeLoginMethod" id="email">Email</span>
    </div>
    <form @submit.prevent="signIn">
      <label class="contact-label" for="phoneOrEmail">
        {{selectedLoginMethod}}
        <span v-if="phoneIsActive.active" class="phone-input-container">
          <input @change="focusOnNextInput(); checkCountryCodeValiidty()"
            type="tel" inputmode="tel" list="country-codes"
            class="country-code-input" v-model="countryCode"
            autocomplete="tel-country-code" required>
          <input
            class="phone-number-input"
            @focus="clearErrors"
            type="tel"
            inputmode="tel"
            v-model="phoneNumber"
            id="phoneOrEmail"
            autocomplete="tel"
            required />
          </span>
        <input v-else
          class="email-input"
          @focus="clearErrors"
          type="email"
          inputmode="email"
          v-model="email"
          id="email"
          autocomplete="email"
          required
        />
        <span v-if="notFound" class="error-message">Este {{loginMethod}}
          não possui nenhuma conta.</span>
        <span v-if="isCountryCodeInvalid" class="error-message">
          Falta o '+' no código do país.</span>
      </label>
      <datalist id="country-codes">
        <option v-for="c in countryCodesList" :value="c.dialCode"
          :key="c.dialCode">{{c.dialCode}}</option>
      </datalist>
      <label class="password-label" for="password"
        >Palavra-passe *
        <input
          @focus="clearErrors"
          :type="inputType"
          v-model="password"
          name="current-password"
          autocomplete="current-password"
          inputmode="text"
          id="password"
          required
        />
        <span v-if="invalidPassword" class="error-message">Palavra-passe incorreta.</span>
      </label>
      <label class="visibility-toggle" for="show-password-button">
        <input @click="isPassword = !isPassword" type="checkbox" id="show-password-button" />
        <span role="button">Mostrar palavra-passe</span>
      </label>
      <AppButton :text="textForButton" :disabled="isSigningIn" />
      <p @click="goToRoute" id="/registar-se" class="link-button" role="button">Regista-te</p>
      <p class="link-button" role="button">Esqueci a minha palavra-passe</p>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import countryCodes from "@/misc/countryCodes";
import AppButton from "../components/AppButton.vue";
import { requestBuilder, parseUserId } from "../misc/util";

export default {
  name: "TheSignIn",
  components: {
    AppButton
  },
  created() {
    this.countryCodesList = countryCodes;
  },
  mounted() {
    this.redirectIfLoggedIn();
    this.checkAuthStatus();
    this.focusOnNextInput();
  },
  data() {
    return {
      password: "",
      phoneNumber: "",
      email: "",
      countryCode: "+258",
      isCountryCodeInvalid: false,
      countryCodesList: [],
      phoneIsActive: {
        active: true
      },
      emailIsActive: {
        active: false
      },
      notFound: false,
      invalidPassword: false,
      isPassword: true,
      isSigningIn: false,
      networkError: false,
      isCORSError: false
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    selectedLoginMethod() {
      if (this.phoneIsActive.active) return "Código do país e Número de celular *";
      return "Email";
    },
    loginMethod() {
      if (this.phoneIsActive.active) return "numero de celular";
      return "email";
    },
    inputType() {
      if (this.isPassword) return "password";
      return "text";
    },
    textForButton() {
      if (this.isSigningIn) return "Entrando...";
      return "Entrar";
    },
    completePhoneNumber() {
      const { length: countryCodeLength } = this.countryCode;
      const { length: phoneNumberLenght } = this.phoneNumber;
      if (countryCodeLength > 0 && phoneNumberLenght > 0) return `${this.countryCode}${this.phoneNumber}`;
      return "";
    },
    requestData() {
      if (this.phoneIsActive.active) {
        return {
          phoneNumber: this.completePhoneNumber,
          password: this.password,
          email: undefined
        };
      } return {
        phoneNumber: undefined,
        password: this.password,
        email: this.email
      };
    }
  },
  methods: {
    ...mapActions(["changeLoginState", "changeUserId", "checkAuthStatus"]),
    reloadPage() {
      this.$router.go(0);
    },
    redirectIfLoggedIn() {
      if (this.isLoggedIn === true) this.$router.push({ name: "accounts" });
    },
    goToRoute(e) {
      const nextRoute = e.srcElement.id;
      const currentRoute = this.$route.path;

      if (currentRoute !== nextRoute) this.$router.push(nextRoute);
    },
    focusOnFirstInput() {
      const countryCodeInput = document.querySelector(".country-code-input");
      if (countryCodeInput) countryCodeInput.focus();
    },
    focusOnNextInput() {
      const phoneNumberInput = document.querySelector(".phone-number-input");
      if (phoneNumberInput) phoneNumberInput.focus();
    },
    focusOnEmailInput() {
      const emailInput = document.querySelector(".email-input");
      if (emailInput) emailInput.focus();
    },
    checkCountryCodeValiidty() {
      if (this.countryCode.length > 0) {
        const hasPlusSign = this.countryCode.includes("+");
        if (hasPlusSign) this.isCountryCodeInvalid = false;
        else this.isCountryCodeInvalid = true;
      } else this.isCountryCodeInvalid = false;
    },
    changeLoginMethod(e) {
      const { target } = e;
      if (target.id === "email") {
        this.focusOnEmailInput();
        this.phoneIsActive.active = false;
        this.emailIsActive.active = true;
      } else {
        this.phoneIsActive.active = true;
        this.emailIsActive.active = false;
        setTimeout(() => {
          this.focusOnFirstInput();
        }, 500);
      }
    },
    clearErrors() {
      this.invalidPassword = false;
      this.notFound = false;
    },
    setErrorMessages(status) {
      if (status === 404) this.notFound = true;
      if (status === 401) this.invalidPassword = true;
    },
    async signIn() {
      if (!this.isCountryCodeInvalid) {
        this.isSigningIn = true;

        const nextRoutePath = "/contas";
        const { path: currentRoutePath } = this.$route;

        const url = "/users/login";
        const method = "POST";
        const data = this.requestData;
        const requestOptions = requestBuilder(url, method, data);

        try {
          const response = await axios.request(requestOptions);
          this.changeUserId(parseUserId());
          this.changeLoginState(true);
          if (currentRoutePath !== nextRoutePath) this.$router.push({ path: nextRoutePath });
        } catch (error) {
          if (error.response.status) {
            if (error.response.status !== 502) {
              this.setErrorMessages(error.response.status);
            } else this.isCORSError = true;
          } else {
            console.log("network is failing");
            this.networkError = true;
          }
          this.isSigningIn = false;
        }
      }
    }
  }
};
</script>

<style scoped>
label {
  color: var(--color-tertiary);
}

button {
  margin: 2px auto 0 auto;
  background-color: var(--color-primary);
  color: var(--color-quaternary);
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.page-description {
  margin-bottom: 1.6rem;
}

.login-options {
  display: flex;
  flex-direction: column;
  margin: 0 auto 1.6rem auto;
}

.phone-number-login, .email-login {
  font-size: 0.874rem;
  background-color:var(--color-white);
  padding: 0.8rem 1.4rem;
  border-radius: 10px;
  margin: 0;
  text-align: center;
  transition: all 800ms ease-in;
  cursor: pointer;
}

.phone-number-login {
  margin-bottom: 1rem;
}

.container form {
  width: 100%;
  margin-bottom: 1.6rem;
}

.active {
  color: var(--color-quinary);
  background-color: var(--color-primary);
}

.contact-label {
  flex-direction: column;
}

.contact-label :nth-child(2) {
  margin: 0 1rem;
  font-weight: 600;
}

.password-label {
  margin: 1.6rem 0 0.8rem 0;
}

.visibility-toggle {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.6rem;
}

.visibility-toggle span {
  margin-top: 0.6px;
}

.visibility-toggle:focus-within {
  color: var(--color-secondary) !important;
}

.phone-input-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
  margin-left: 0!important;
}

.country-code-input,
.phone-number-input {
  width: 100%;
}

.country-code-input {
  grid-column: 1/3;
  border-radius: 10px 0 0 10px;
  border-right: 0;
  background-color: #FFCD56;
}

.phone-number-input {
  grid-column: 3/6;
  border-radius: 0 10px 10px 0;
  border-left: 0;
  margin-left: 0!important;
  font-weight: normal!important;
}

.full-width {
  display: flex;
}

.email-input {
  margin-left: 0!important;
  margin-right: 0!important;
  color: var(--color-primary)!important;
  font-weight: normal!important;
}

.error-message {
  font-size: 0.833rem;
  color: var(--color-senary);
}

.error-cors-message {
  font-size: 0.833rem;
  color: var(--color-white);
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  background-color: var(--color-senary);
  width: fit-content;
  text-align: center;
  margin: 0 auto 1.8rem auto!important;
  cursor: pointer;
}

.link-button {
  color: var(--color-secondary);
  text-align: center;
  cursor: pointer;
}

.link-button:first-of-type {
  margin: 1.6rem 0 0.8rem 0;
}
</style>
